/**
 * №13.2 §2.2 — the Clients LENS (`/app/clients`). One Contacts master, many
 * lenses: this Place lists contacts holding the `client` role on any matter
 * (a matter_party join the declared-list renderer can't express — served by the
 * `list_client_contacts` verb). Rows link to the contact's four-plane record.
 * Creating a contact is done from the Contacts surface / intake; this is the
 * client-role view, not a separate table.
 */
import { useNavigate } from "react-router";
import { useClientContacts } from "../../hooks/use-time-billing";
import { TableSubjectHead } from "./TableSubjectHead";

export function ClientsPage() {
  const navigate = useNavigate();
  const clients = useClientContacts();
  const rows = clients.data ?? [];

  // №14.1.1-B defect 4 — Contacts ↔ Clients consistency. This lens used to put
  // its title INSIDE a `.surface__bar` (the ledger record-header component) while
  // its sibling Places put theirs in a `.pagehead` above the card, so two lists
  // of the same thing looked like two different products. Both are now
  // pagehead + card-with-table, and status reads as the canonical lifecycle
  // `.pill`, not an identity `.badge`.
  return (
    <div className="screen">
      <TableSubjectHead
        title="Clients"
        sub={<>{rows.length} client{rows.length === 1 ? "" : "s"} · contacts holding the client role · one Contacts master, many lenses</>}
      />
      <div className="card card--flush">
        {clients.isLoading ? (
          <div className="skeleton"><div className="sk-line" style={{ width: "60%" }} /><div className="sk-line" style={{ width: "40%" }} /></div>
        ) : rows.length === 0 ? (
          <div className="empty-state">
            <h3>No clients yet</h3>
            <p>A contact becomes a client when it holds the client role on a matter (set it from the matter's Parties list, or at intake).</p>
          </div>
        ) : (
          <div className="table-scroll">
            <table>
              <thead><tr><th>Client</th><th>Type</th><th>Email</th><th className="num">Matters</th><th>Status</th></tr></thead>
              <tbody>
                {rows.map((c) => (
                  <tr key={c.id} onClick={() => navigate(`/app/place/contact/${c.id}`)} style={{ cursor: "pointer" }}>
                    <td className="primary">{c.name ?? c.id}</td>
                    <td className="muted">{c.kind ?? "—"}</td>
                    <td className="muted">{c.email ?? "—"}</td>
                    <td className="num">{c.matter_count}</td>
                    <td>{c.status ? <span className={`pill pill--${c.status}`}><span className="dot" />{c.status}</span> : "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
